<template>
  <div>
    <el-table :data="tracks" class="w100" stripe>
      <el-table-column label="Name" prop="track.title"></el-table-column>
      <el-table-column
        label="VC Balance"
        prop="balance"
      ></el-table-column>
      <el-table-column label="Campaign start">
        <template slot-scope="props">
          {{ props.row.campaign_track_start | date }}
        </template>
      </el-table-column>
      <el-table-column label="Campaign end">
        <template slot-scope="props">
          {{ props.row.campaign_track_end | date }}
        </template>
      </el-table-column>
      <el-table-column label="Actions" align="right">
        <template slot-scope="props">
          <el-tooltip content="Deposit" placement="top">
            <el-button
              type="warning"
              circle
              size="small"
              icon="el-icon-money"
              @click="openDeposit(props.row)"
            ></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  computed: {
    ...mapState('labelTrackVidCents', ['tracks'])
  },

  methods: {
    ...mapMutations('labelTrackVidCents', ['setTrack', 'setTrackDeposit']),

    openDeposit(row) {
      this.setTrackDeposit(true)
      this.setTrack(row)
    }
  }
}
</script>
